import { createBrowserRouter, Navigate } from 'react-router-dom';

import { Admin } from '../pages/Admin/Admin.tsx';
import { Home } from '../pages/Home/Home.tsx';
import { routes } from './routes.ts';

const router = createBrowserRouter([
  { path: routes.home, element: <Home /> },
  { path: routes.admin, element: <Admin /> },
  { path: '*', element: <Navigate to="/" /> },
]);

export { router };
